import { render } from "./AssetCompareDialog.vue?vue&type=template&id=60a054bc&scoped=true"
import script from "./AssetCompareDialog.vue?vue&type=script&lang=js"
export * from "./AssetCompareDialog.vue?vue&type=script&lang=js"

import "./AssetCompareDialog.vue?vue&type=style&index=0&id=60a054bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a054bc"]])

export default __exports__